import React from "react";
import { Button, Card, Typography } from "antd";
import { useLocation, Navigate } from "react-router-dom";

const { Title, Paragraph } = Typography;

const PHONE_BY_UNIT = {
  tatuape: "5511939422820",
  ipiranga: "5511956670040",
};

function pushDL(event, payload = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    ...payload,
  });
}


function humanObjective(v) {
  const map = {
    leitura: "Leitura",
    computador: "Trabalhar em frente ao computador",
    presbiopia: "Corrigir presbiopia (perto e longe)",
    orientacao: "Não sei, preciso de orientação",
  };
  return map[v] || "—";
}

function humanPrescription(v) {
  const map = {
    sim: "✅ Sim (tenho receita em mãos)",
    nao: "❌ Não tenho receita",
  };
  return map[v] || "—";
}

function humanInterest(v) {
  const map = {
    armacao: "Comprar armação nova",
    lentes: "Comprar lentes novas",
    oculos_completos: "Ver promoções de óculos completos",
  };
  return map[v] || "—";
}

function humanUnit(v) {
  const map = { tatuape: "Tatuapé", ipiranga: "Ipiranga" };
  return map[v] || "—";
}

function buildWhatsAppText(a) {
  const nome = (a?.name || "").trim() || "Cliente";
  const cupom = a?.coupon || "PRIMEIRACOMPRA";

  return [
    `Olá! Me chamo *${nome}* e fiz o quiz da *Óticas Bluevision* 😊`,
    ``,
    `*Resumo do atendimento:*`,
    `• Objetivo: *${humanObjective(a?.objective)}*`,
    `• Receita: *${humanPrescription(a?.hasPrescription)}*`,
    `• Interesse: *${humanInterest(a?.interest)}*`,
    `• Unidade: *${humanUnit(a?.unit)}*`,
    ``,
    `*Cupom:* ${cupom}`,
  ].join("\n");
}

function buildWaLink(a) {
  const unit = a?.unit || "tatuape";
  const phone = PHONE_BY_UNIT[unit] || PHONE_BY_UNIT.tatuape;
  const text = buildWhatsAppText(a);
  return `https://wa.me/${phone}?text=${encodeURIComponent(text)}`;
}

export default function Success() {
  const { state } = useLocation();
  const answers = state?.answers;

  // ✅ early return OK (sem hooks depois disso)
  if (!answers) return <Navigate to="/quiz" replace />;

  // ✅ sem useMemo -> sem regra de hooks
  const waUrl = buildWaLink(answers);

  return (
    <div className="bv-page">
      <div className="bv-container">

        {/* 🔵 NOVA IMAGEM TOPO */}
        <div className="bv-hero-image">
          <img
            src={process.env.PUBLIC_URL + "/mulher.png"}
            alt="Óticas Bluevision"
            className="bv-hero-img"
          />
        </div>

        <Card className="bv-card" bordered={false}>


          <Paragraph className="bv-subtext">
            Nosso time te orienta rapidinho. Ao clicar, já enviamos seu resumo no WhatsApp.
          </Paragraph>

          <Button
            type="primary"
            size="large"
            className="bv-primary"
            onClick={() => {
              // ✅ evento para GTM (sem PII)
              pushDL("bv_whatsapp_click", {
                unit: answers.unit || "tatuape",
                objective: answers.objective || null,
                hasPrescription: answers.hasPrescription || null,
                interest: answers.interest || null,
                coupon: answers.coupon || "PRIMEIRACOMPRA",
              });

              // abre o WhatsApp
              window.location.assign(waUrl);
            }}
          >
            Falar com equipe especialista!
          </Button>

        </Card>
      </div>
    </div>
  );
}
